/**
 * Settings › Default parameters — platform-wide default knobs that don't
 * belong to a listing. Currently: notification-log retention (keep-until).
 */

import React from "react";
import { useTranslate } from "react-admin";
import { Box, Typography, useTheme } from "@mui/material";
import KeepUntilBar from "./KeepUntilBar";

const i18nBase = "pages.settings";

export const DefaultParametersPage: React.FC = () => {
  const translate = useTranslate();
  const theme = useTheme();
  const rg = theme.custom.rg;
  return (
    <Box sx={{ maxWidth: 720 }}>
      <Typography
        variant="h4"
        sx={{ fontWeight: 700, color: "text.primary", mb: 3, ml: 2 }}
      >
        {translate(`${i18nBase}.defaultParameters`, { _: "Default parameters" })}
      </Typography>

      <Box sx={{ ml: 2 }}>
        <Typography
          sx={{
            fontSize: "10.5px",
            fontWeight: 600,
            letterSpacing: "0.05em",
            textTransform: "uppercase",
            color: rg.text3,
            mb: 1,
          }}
        >
          {translate("resources.notification-logs.name", {
            smart_count: 2,
            _: "Notification Logs",
          })}
        </Typography>
        <KeepUntilBar />
      </Box>
    </Box>
  );
};

export default DefaultParametersPage;
